module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['navigation-bar', {
      'navigation-bar--open': _vm.isOpen
    }]
  }, [_c('button', {
    staticClass: "navigation-bar__toggle-icon",
    on: {
      "click": _vm.toggleNavigation
    }
  }, [_c('span', {
    class: [{
      'active': _vm.isOpen
    }]
  })]), _vm._v(" "), _c('div', {
    staticClass: "navigation-bar__contest-name"
  }, [(_vm.lang === 'en') ? [_c('img', {
    attrs: {
      "src": "/dist/mentos-logo-en.png"
    }
  }), _vm._v(" "), _vm._m(0)] : _vm._e(), _vm._v("\n\n    " + _vm._s(_vm.$t("navigationBar.title", _vm.lang)) + "\n\n    "), (_vm.lang === 'fr') ? [_vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/dist/mentos-logo-fr.png"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('nav', {
    staticClass: "navigation-bar__list"
  }, [_c('ul', [_c('li', [_c('button', {
    staticClass: "navigation-bar__list-item",
    on: {
      "click": function($event) {
        _vm.scrollToSection('#contest-vue')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("navigationBar.backToTop", _vm.lang)))])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "navigation-bar__list-item",
    on: {
      "click": function($event) {
        _vm.scrollToSection('#map-and-feeds')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("navigationBar.niceToMentosYou", _vm.lang)))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "navigation-bar__list-item",
    attrs: {
      "href": _vm.$t('navigationBar.goToMentosUrl', _vm.lang),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("navigationBar.goToMentos", _vm.lang)))])]), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "navigation-bar__list-item",
    on: {
      "click": _vm.toggleLanguage
    }
  }, [_vm._v(_vm._s(_vm.$t("navigationBar.language", _vm.lang)))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Mentos")]), _vm._v(" presents")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("présenté par "), _c('b', [_vm._v("Mentos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df10763c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
// module id = 177
// module chunks = 0